export default function isExternalAudit() {
    const fullName = localStorage.getItem('fullName');

    return fullName === 'Auditoría Externa';
}